module.exports = __webpack_public_path__ + "4ed5f578e232a6412226427cd0aaaf74.png";